import type { ChangelogEntry } from "../types";

/** Oppdag ryddet: Avvis uten grunn, færre innganger, og kontakter kan legges til der de trengs. */
export const OPPDAG_RYDDET_2026_10: ChangelogEntry = {
  id: "2026-10-27-oppdag-ryddet",
  date: "2026-10-27",
  title: "Oppdag er ryddet, og kontakter kan legges til der du trenger dem",
  summary:
    "Øverst i Oppdag står dine tall i stedet for «Din uke». Avvis sveiper oppfølgingen ut uten å spørre om grunn. Book møte, signallisten, streak og «Uten eier» er borte. I e-post, samtale og Book møte kan du legge til eller rette kontaktpersonen.",
  sections: [
    {
      heading: "Salgsmuligheter",
      minRole: "user",
      items: [
        {
          title: "Dine tall i stedet for «Din uke»",
          kind: "nytt",
          featureFlag: "feature_crm_ko_pipe",
          body: "Øverst i Oppdag står kontakter i dag, kontakter denne uken, møter booket denne uken og oppfølginger igjen denne uken. Streaken er fjernet.",
        },
        {
          title: "Avvis i stedet for Avslutt",
          kind: "forbedret",
          featureFlag: "feature_crm_ko_pipe",
          body: "«Avvis» (4, pil venstre eller dra til venstre) sveiper oppfølgingen ut som signalkortet og lukker den uten å spørre om grunn. «Ikke aktuelt nå» i samtalen lukker fortsatt med notatet som grunn.",
        },
        {
          title: "Ingen «Hvorfor?» etter Avvis på signaler",
          kind: "forbedret",
          featureFlag: "feature_crm_signaler",
          body: "Avvis på et signal er ett klikk igjen. Agentene lærer fortsatt av hvilke signaler som avvises og tas.",
        },
        {
          title: "Færre knapper i Oppdag",
          kind: "forbedret",
          featureFlag: "feature_crm_ko_pipe",
          body: "Book møte er ikke lenger en egen knapp på kortene, møtet bookes fra samtalen. «Annet neste steg» i samtalen, signallisten og «Uten eier» er fjernet.",
        },
        {
          title: "Legg til eller rett kontaktperson",
          kind: "nytt",
          featureFlag: "feature_crm_ko_pipe",
          body: "I e-postdialogen, samtalen og Book møte kan du velge en annen kontakt, legge til en ny eller rette den valgte. I samtalen velger du hvem du ringer.",
        },
        {
          title: "Leadkortet er enklere",
          kind: "forbedret",
          featureFlag: "feature_crm_leads_moter",
          body: "Notatfeltet (N) og listenavnet er fjernet fra leadkortet.",
        },
      ],
    },
  ],
};
